
export const Theme = {
  header: [
    'text-sm text-neutral-700 bg-white border-b',
    'dark:bg-gray-700 dark:text-gray-400 dark:border-gray-700'
  ],
  bordered: [
    'bg-white border-b',
    'dark:bg-gray-800 dark:border-gray-700'
  ]
};
